import { brandService, categoryService, strainService } from '../services';
import { store_type, genetics, avgRating } from './staticFiltes'

const sorts = {
    brandsPage:[
        {
            label: 'Sort by ',
            icon: 'bx bx-sort',
            opts: [
                {label:"Name A-Z", sortField:"name", sortOrder:"asc", default:true},
                {label:"Name Z-A", sortField:"name", sortOrder:"desc", default:true},
            ]
        }
    ],

    brandMenuPage:[
        {
            label: 'Sort by',
            icon: 'bx bx-sort',
            opts: [
                
                // {label:"Relevance", sortField:"score", sortOrder:"desc", default:true},
                // {label:"Distance", sortField:"calcDistance", sortOrder:"asc"},
                {label:"Name A-Z", sortField:"name", sortOrder:"asc", default: true},
                {label:"Name Z-A", sortField:"name", sortOrder:"desc"},
                // {label:"Name", sortField:"name", sortOrder:"asc", default:true},
                {label:"Rating", sortField:"avgRating", sortOrder:"desc"},
                // {label:"Lower Price", sortField:"lowerPrice", sortOrder:"asc"}
            ]
        }
    ],

    dispensariesPage:{
        
    },

    dispensaryMenuPage:[
        {
            label: 'Sort by',
            icon: 'bx bx-sort',
            opts: [
                {label:"Relevance", sortField:"totalScore", sortOrder:"desc", default:true},
                {label:"Most Reviewed", sortField:"reviewsAmt", sortOrder:"desc"},
                {label:"Rating", sortField:"avgRating", sortOrder:"desc"},
                {label:"Name A-Z", sortField:"name", sortOrder:"asc"},
                {label:"Name Z-A", sortField:"name", sortOrder:"desc"},
            ]
        }
    ],

    StrainsPage:[
        {
            label: 'Sort by',
            icon: 'bx bx-sort',
            opts: [
                {label:"Name A-Z", sortField:"name", sortOrder:"asc", default:true},
                {label:"Name Z-A", sortField:"name", sortOrder:"desc", default:true},
            ]
        }
    ],

    StrainMenuPage:{
       
    },

    productsPage:[
        {
            label: 'Sort by',
            icon: 'bx bx-sort',
            opts: [
                {label:"Relevance", sortField:"totalScore", sortOrder:"desc", default:true},
                {label:"Most Reviewed", sortField:"reviewsAmt", sortOrder:"desc"},
                {label:"Rating", sortField:"avgRating", sortOrder:"desc"},
                {label:"Name A-Z", sortField:"name", sortOrder:"asc"},
                {label:"Name Z-A", sortField:"name", sortOrder:"desc"},
            ]
        }
    ],

    ordersPage:[
        {
            label: 'Sort by',
            icon: 'bx bx-sort',
            opts: [
                {label:"Date", sortField:"createdAt", sortOrder:"desc", default:true},
                {label:"Amount $", sortField:"total", sortOrder:"desc"},
            ]
        }
    ]
}


export default sorts